// extracted by mini-css-extract-plugin
export const allCorners = "Blocks__allCorners__N2BUz Blocks__bottomCorners__1NWrS Blocks__topCorners__CmagV";
export const atlasGrotesk = "'AtlasGrotesk'";
export const bold = "700";
export const bottomCorners = "Blocks__bottomCorners__1NWrS";
export const cardBlock = "Blocks__cardBlock__cn53P";
export const expanded = "Blocks__expanded__HJuU2";
export const forceRoundedCorners = "Blocks__forceRoundedCorners__HnhRP";
export const fullHeight = "Blocks__fullHeight__I5LRB";
export const headBgColorExternal = "var(--salt)";
export const headBgColorInternal = "var(--shade)";
export const headBgColorShrunkSidebar = "var(--slate)";
export const medium = "500";
export const mediumShadow = "Blocks__mediumShadow__vQFSp";
export const noBorders = "Blocks__noBorders__yc1Y8";
export const noShadow = "Blocks__noShadow__T04M2";
export const notification = "Blocks__notification__6wr5E";
export const notificationInner = "Blocks__notificationInner__sW47s";
export const regular = "400";
export const sans = "'sans'";
export const semibold = "600";
export const serif = "'serif'";
export const softShadow = "Blocks__softShadow__P3v0M";
export const topCorners = "Blocks__topCorners__CmagV";
export const withPadding = "Blocks__withPadding__b2xW4";
export const withShadow = "Blocks__withShadow__p+OuH";